import { render, staticRenderFns } from "./UuidApp.vue?vue&type=template&id=1043bd94&"
import script from "./UuidApp.vue?vue&type=script&lang=js&"
export * from "./UuidApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports